// extracted by mini-css-extract-plugin
export var active = "_ij-2";
export var recordingDot = "_ij-1";
export var recordingIndicator = "_ij-0";